const aboutUsItemsPosition = () => {
  let res = resolutionCheck();
  if ($('.about-us').length && res > 32) {
    res = resolutionCheck();
    $('.about-us').each(function () {
      $(this).masonry({
        // options...
        itemSelector: '.about-us__item',
        transitionDuration: 0,
      });

      /* add translateX to right positioned items */
      let parentWidth = $(this).width(),
        colNumb,
        space = 32,
        spaceWidth = space * 2,
        colWidth,
        translateX;
      if (res > 76) {
        colNumb = 7;
      } else {
        colNumb = 5;
      }
      (colWidth = (parentWidth - (colNumb - 1) * space) / colNumb),
        (translateX = colWidth + spaceWidth);
      $(this)
        .find('.about-us__item')
        .each(function () {
          if ($(this).css('left') != '0px') {
            $(this).css('transform', 'translateX(' + translateX + 'px)');
          } else {
            $(this).css('transform', 'translateX(0)');
          }
        });
    });
  }
};

$(document).ready(function () {
  aboutUsItemsPosition();
});

$(window).on('load resize orientationchange', function () {
  aboutUsItemsPosition();
});
